import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Pendaftaran Rawat Jalan Online"),
  /*#__PURE__*/_createTextVNode(" Pendaftaran Online adalah fitur yang digunakan untuk mendaftar dilayanan rawat jalan. ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://wa.me/+6281232009725"
}, "Klik Link ini.", -1)
const _hoisted_3 = { class: "grid align-items-center justify-content-center" }
const _hoisted_4 = {
  key: 0,
  class: "hidden lg:block col-12 md:col-12 lg:col-3 xl:col-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, null, -1)
const _hoisted_6 = { class: "col-12 md:col-12 lg:col-6 xl:col-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-base md:text-xl" }, "Syarat Pendaftaran Online", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "m-0"
}
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = { class: "flex justify-content-center flex-wrap" }
const _hoisted_17 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-base md:text-xl" }, "Pilih Jenis / Status Pendaftaran", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold" }, "Silahkan Pilih", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_21 = { class: "m-0" }
const _hoisted_22 = { class: "grid justify-content-center align-content-center" }
const _hoisted_23 = { class: "col-12 md:col-6 lg:col-4 xl:col-4 justify-content-center align-content-center" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "col-12 md:col-6 lg:col-4 xl:col-4 justify-content-center align-content-center" }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_28 = { class: "flex justify-content-center" }
const _hoisted_29 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "text-base md:text-xl" }, "Input Data Pasien", -1)
const _hoisted_31 = { class: "text-base font-bold" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_33 = { class: "m-0" }
const _hoisted_34 = { class: "flex flex-column gap-2" }
const _hoisted_35 = {
  class: "font-bold",
  for: "no_rm"
}
const _hoisted_36 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_37 = {
  key: 0,
  class: "flex flex-column gap-2 mt-5"
}
const _hoisted_38 = {
  class: "font-bold",
  for: "no_bpjs"
}
const _hoisted_39 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_41 = { class: "flex justify-content-center flex-wrap" }
const _hoisted_42 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_43 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "text-base md:text-xl" }, "Poli dan Tanggal", -1)
const _hoisted_45 = { class: "text-base font-bold" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_47 = { class: "m-0" }
const _hoisted_48 = { class: "text-base font-bold" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", null, "Nomor RM", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", null, ":", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", null, "Nama", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", null, ":", -1)
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, ":", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold mt-4" }, "Silahkan Pilih Poli dan Tanggal :", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_59 = { class: "m-0" }
const _hoisted_60 = { class: "mt-4" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold" }, "Silahkan Pilih Poli :", -1)
const _hoisted_62 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_63 = { class: "font-bold" }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "flex align-items-center" }
const _hoisted_66 = { class: "bg-primary border-circle w-2rem h-2rem flex align-items-center justify-content-center" }
const _hoisted_67 = { class: "ml-2 font-medium" }
const _hoisted_68 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_69 = { class: "m-0" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", null, "faskes", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", null, ":", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", null, "nomor rujukan", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", null, ":", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", null, "tgl dibuat", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("td", null, ":", -1)
const _hoisted_76 = { class: "mt-6" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold" }, "Silahkan Pilih Tanggal Pemeriksaan :", -1)
const _hoisted_78 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_79 = { class: "font-bold" }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "flex flex-column" }
const _hoisted_82 = { class: "flex" }
const _hoisted_83 = { class: "ml-2 font-medium" }
const _hoisted_84 = { class: "flex" }
const _hoisted_85 = { class: "text-red-500 p-1 ml-1" }
const _hoisted_86 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_87 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold" }, "Silahkan Pilih Dokter :", -1)
const _hoisted_89 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_90 = { class: "font-bold" }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { class: "flex flex-column" }
const _hoisted_93 = { class: "flex" }
const _hoisted_94 = { class: "ml-2 font-medium" }
const _hoisted_95 = { class: "flex" }
const _hoisted_96 = { class: "text-red-500 p-1 ml-1" }
const _hoisted_97 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold" }, "Silahkan Masukan Nomor Surat Kontrol anda :", -1)
const _hoisted_99 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_100 = { class: "mt-6" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold" }, "Silahkan Masukan Nomor Handphone yang dapat dihubungi :", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_103 = { class: "flex justify-content-center flex-wrap" }
const _hoisted_104 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_105 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "text-base md:text-xl" }, "Antrian Anda", -1)
const _hoisted_107 = {
  key: 0,
  class: "m-0"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_109 = { class: "flex justify-content-center flex-wrap" }
const _hoisted_110 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_111 = {
  key: 1,
  class: "col-12 md:col-12 lg:col-3 xl:col-3"
}
const _hoisted_112 = { class: "flex flex-column align-items-center p-5 surface-overlay border-round" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info text-5xl" })
], -1)
const _hoisted_114 = { class: "font-bold text-xl block mb-2 mt-4" }
const _hoisted_115 = { class: "mb-0 text-lg" }
const _hoisted_116 = { class: "flex align-items-center gap-2 mt-4" }

export function render(_ctx, _cache) {
  const _component_loading = _resolveComponent("loading")
  const _component_p_message = _resolveComponent("p-message")
  const _component_p_card = _resolveComponent("p-card")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_p_skeleton = _resolveComponent("p-skeleton")
  const _component_p_button = _resolveComponent("p-button")
  const _component_p_inputtext = _resolveComponent("p-inputtext")
  const _component_p_badge = _resolveComponent("p-badge")
  const _component_p_chip = _resolveComponent("p-chip")
  const _component_p_dropdown = _resolveComponent("p-dropdown")
  const _component_p_fieldset = _resolveComponent("p-fieldset")
  const _component_antrian = _resolveComponent("antrian")
  const _component_p_confirm_dialog = _resolveComponent("p-confirm-dialog")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = $event => ((_ctx.isLoading) = $event)),
      "can-cancel": false,
      "is-full-page": true,
      loader: "bars"
    }, null, 8, ["active"]),
    _hoisted_1,
    _createVNode(_component_p_message, {
      severity: "warn",
      closable: false
    }, {
      default: _withCtx(() => [
        _createTextVNode("Khusus Pasien Yang belum Mempunyai No. RM (Rekam Medis) silahkan "),
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_p_message, {
      severity: "info",
      closable: false
    }, {
      default: _withCtx(() => [
        _createTextVNode("Khusus Pasien Yang sudah Memiliki nomor Rekamedis / RM / Nomor Pasien")
      ]),
      _: 1
    }),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_p_message, {
          key: 0,
          severity: "error"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.success)
      ? (_openBlock(), _createBlock(_component_p_message, {
          key: 1,
          severity: "success"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.success), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isIklan)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_p_card, { class: "mb-5 card" }, {
              content: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.posisi == 1)
          ? (_openBlock(), _createBlock(_component_p_card, {
              key: 0,
              class: "mb-5 card"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'square-check'] }),
                _createTextVNode(),
                _hoisted_7
              ]),
              content: _withCtx(() => [
                _hoisted_8,
                (_ctx.isLodingSyarat)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", _hoisted_10, [
                          _createVNode(_component_p_skeleton, {
                            height: "2rem",
                            class: "mb-2",
                            borderRadius: "16px"
                          })
                        ]),
                        _createElementVNode("li", _hoisted_11, [
                          _createVNode(_component_p_skeleton, {
                            height: "2rem",
                            class: "mb-2",
                            borderRadius: "16px"
                          })
                        ]),
                        _createElementVNode("li", _hoisted_12, [
                          _createVNode(_component_p_skeleton, {
                            height: "2rem",
                            class: "mb-2",
                            borderRadius: "16px"
                          })
                        ]),
                        _createElementVNode("li", _hoisted_13, [
                          _createVNode(_component_p_skeleton, {
                            height: "2rem",
                            class: "mb-2",
                            borderRadius: "16px"
                          })
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      innerHTML: _ctx.syarat_jenis.syarat
                    }, null, 8, _hoisted_14)),
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (!_ctx.isLodingSyarat)
                      ? (_openBlock(), _createBlock(_component_p_button, {
                          key: 0,
                          onClick: _ctx.lanjut,
                          severity: "success",
                          rounded: "",
                          outlined: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Lanjut "),
                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'circle-right'] })
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.posisi == 2)
          ? (_openBlock(), _createBlock(_component_p_card, {
              key: 1,
              class: "mb-5 card"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'money-bills'] }),
                _createTextVNode(),
                _hoisted_18
              ]),
              content: _withCtx(() => [
                _hoisted_19,
                _hoisted_20,
                _createElementVNode("p", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("img", {
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.pilihJenis({id:1, type: 'TUNAI'}))),
                        width: "100%",
                        src: require(`@/assets/p-umum.png`),
                        alt: ""
                      }, null, 8, _hoisted_24)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("img", {
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$router.push('/mjkn'))),
                        width: "100%",
                        src: require(`@/assets/m-jkn.png`),
                        alt: ""
                      }, null, 8, _hoisted_26)
                    ])
                  ])
                ]),
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_p_button, {
                      onClick: _ctx.kembali,
                      severity: "info",
                      rounded: "",
                      outlined: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'circle-left'] }),
                        _createTextVNode(" Kembali")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.posisi == 3)
          ? (_openBlock(), _createBlock(_component_p_card, {
              key: 2,
              class: "mb-5 card"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'address-card'] }),
                _createTextVNode(),
                _hoisted_30
              ]),
              content: _withCtx(() => [
                _createElementVNode("span", _hoisted_31, "Data Pasien " + _toDisplayString(_ctx.jenis.nama) + " :", 1),
                _hoisted_32,
                _createElementVNode("p", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, [
                      _createTextVNode("Silahkan Masukan Nomor Rekam Medis (RM) Anda : "),
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'hand-point-down'] })
                    ]),
                    _createVNode(_component_p_inputtext, {
                      modelValue: _ctx.no_rm,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.no_rm) = $event)),
                      type: "number",
                      placeholder: "klik disini untuk isi nomor RM",
                      autofocus: ""
                    }, null, 8, ["modelValue"]),
                    (_ctx.errors.no_rm)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.errors.no_rm), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.jenis.type=='BPJS')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("label", _hoisted_38, [
                          _createTextVNode("Silahkan Masukan Nomor BPJS/KIS/NIK Anda : "),
                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'hand-point-down'] })
                        ]),
                        _createVNode(_component_p_inputtext, {
                          modelValue: _ctx.no_bpjs,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.no_bpjs) = $event)),
                          type: "number",
                          placeholder: "klik disini untuk isi nomor BPJS/KIS/NIK"
                        }, null, 8, ["modelValue"]),
                        (_ctx.errors.no_bpjs)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.errors.no_bpjs), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_p_button, {
                      onClick: _ctx.backTwo,
                      severity: "info",
                      rounded: "",
                      outlined: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'circle-left'] }),
                        _createTextVNode(" Kembali")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_p_button, {
                      onClick: _ctx.toFour,
                      severity: "success",
                      rounded: "",
                      outlined: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Lanjut "),
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'circle-right'] })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.posisi == 4)
          ? (_openBlock(), _createBlock(_component_p_card, {
              key: 3,
              class: "mb-5 card"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'calendar-check'] }),
                _createTextVNode(),
                _hoisted_44
              ]),
              content: _withCtx(() => [
                _createElementVNode("span", _hoisted_45, "Data Pasien " + _toDisplayString(_ctx.jenis.type) + " :", 1),
                _hoisted_46,
                _createElementVNode("p", _hoisted_47, [
                  _createElementVNode("table", _hoisted_48, [
                    _createElementVNode("tr", null, [
                      _hoisted_49,
                      _hoisted_50,
                      _createElementVNode("td", null, _toDisplayString(_ctx.data_pasien.no_rm), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_51,
                      _hoisted_52,
                      _createElementVNode("td", null, _toDisplayString(_ctx.data_pasien.nama), 1)
                    ]),
                    (_ctx.jenis.type == 'BPJS')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                          _createElementVNode("td", null, "Nomor " + _toDisplayString(_ctx.no_bpjs.length == 13 ? 'BPJS' : '') + " " + _toDisplayString(_ctx.no_bpjs.length == 16 ? 'NIK/KTP' : ''), 1),
                          _hoisted_54,
                          _createElementVNode("td", null, _toDisplayString(_ctx.no_bpjs), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_55,
                _hoisted_56,
                _hoisted_57,
                _hoisted_58,
                _createElementVNode("p", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createVNode(_component_p_dropdown, {
                      onChange: _ctx.changePoli,
                      modelValue: _ctx.selectedPoli,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.selectedPoli) = $event)),
                      filter: "",
                      options: _ctx.data_pasien.poli,
                      optionLabel: "nama_poli",
                      placeholder: "klik disini untuk pilih poli",
                      class: "w-full"
                    }, {
                      value: _withCtx((slotProps) => [
                        (slotProps.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createVNode(_component_p_badge, {
                                  value: slotProps.value.kode_poli
                                }, null, 8, ["value"]),
                                _createTextVNode(" " + _toDisplayString(slotProps.value.nama_poli), 1)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(slotProps.placeholder), 1))
                      ]),
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_p_chip, { class: "py-0 pl-0 pr-3" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_66, _toDisplayString(slotProps.option.kode_poli), 1),
                              _createElementVNode("span", _hoisted_67, _toDisplayString(slotProps.option.nama_poli), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue", "options"]),
                    (_ctx.errors.poli)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.errors.poli), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPoli && _ctx.jenis.type == 'BPJS')
                      ? (_openBlock(), _createBlock(_component_p_fieldset, {
                          key: 1,
                          legend: "rujukan",
                          toggleable: true,
                          class: "mt-3"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_69, [
                              _createElementVNode("table", null, [
                                _createElementVNode("tr", null, [
                                  _hoisted_70,
                                  _hoisted_71,
                                  _createElementVNode("td", null, _toDisplayString(_ctx.selectedPoli.rujukan.nama_faskes), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_72,
                                  _hoisted_73,
                                  _createElementVNode("td", null, _toDisplayString(_ctx.selectedPoli.rujukan.pos_opname ? "POS" : _ctx.selectedPoli.rujukan.kode_poli) + " : " + _toDisplayString(_ctx.selectedPoli.rujukan.no_rujukan), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_74,
                                  _hoisted_75,
                                  _createElementVNode("td", null, _toDisplayString(_ctx.selectedPoli.rujukan.tgl_dibuat), 1)
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _hoisted_77,
                    _createVNode(_component_p_dropdown, {
                      disabled: !_ctx.date_range.length,
                      onChange: _ctx.changeDate,
                      modelValue: _ctx.selectedDate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.selectedDate) = $event)),
                      filter: "",
                      options: _ctx.date_range,
                      optionLabel: "tgl",
                      placeholder: "klik disini untuk pilih Tanggal",
                      class: "w-full",
                      optionDisabled: "disabled"
                    }, {
                      value: _withCtx((slotProps) => [
                        (slotProps.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                              _createElementVNode("div", _hoisted_79, _toDisplayString(slotProps.value.hari) + " : " + _toDisplayString(slotProps.value.tgl), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(slotProps.placeholder), 1))
                      ]),
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createVNode(_component_p_chip, { class: "py-0 pl-0 pr-3" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["border-circle w-2rem h-2rem flex align-items-center justify-content-center", {'bg-green-500' : slotProps.option.status, 'bg-red-500' : !slotProps.option.status}])
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: slotProps.option.disabled ? ['fas', 'xmark'] : ['fas', 'arrow-pointer']
                                  }, null, 8, ["icon"])
                                ], 2),
                                _createElementVNode("span", _hoisted_83, _toDisplayString(slotProps.option.hari) + " : " + _toDisplayString(slotProps.option.tgl), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", _hoisted_84, [
                            (slotProps.option.disabled)
                              ? (_openBlock(), _createBlock(_component_p_chip, {
                                  key: 0,
                                  class: "py-0 pl-0 pr-3 ml-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_85, _toDisplayString(slotProps.option.keterangan), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled", "onChange", "modelValue", "options"]),
                    (_ctx.errors.tanggal)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(_ctx.errors.tanggal), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.selectedDate?.dokter.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                        _hoisted_88,
                        _createVNode(_component_p_dropdown, {
                          disabled: !_ctx.selectedDate?.dokter.length,
                          onChange: _ctx.changeDokter,
                          modelValue: _ctx.selectedDokter,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.selectedDokter) = $event)),
                          filter: "",
                          options: _ctx.selectedDate.dokter,
                          optionLabel: "nama_dokter",
                          placeholder: "klik disini untuk pilih Dokter",
                          class: "w-full",
                          optionDisabled: "disabled"
                        }, {
                          value: _withCtx((slotProps) => [
                            (slotProps.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'user-doctor'] }),
                                    _createTextVNode(" " + _toDisplayString(slotProps.value.nama_dokter), 1)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(slotProps.placeholder), 1))
                          ]),
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("div", _hoisted_93, [
                                _createVNode(_component_p_chip, { class: "py-0 pl-0 pr-3" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["border-circle w-2rem h-2rem flex align-items-center justify-content-center", {'bg-green-500' : slotProps.option.status, 'bg-red-500' : !slotProps.option.status}])
                                    }, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: slotProps.option.disabled ? ['fas', 'stethoscope'] : ['fas', 'user-doctor']
                                      }, null, 8, ["icon"])
                                    ], 2),
                                    _createElementVNode("span", _hoisted_94, _toDisplayString(slotProps.option.nama_dokter), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_95, [
                                (slotProps.option.disabled)
                                  ? (_openBlock(), _createBlock(_component_p_chip, {
                                      key: 0,
                                      class: "py-0 pl-0 pr-3 ml-4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_96, _toDisplayString(slotProps.option.keterangan), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled", "onChange", "modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.wajib_kontrol)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                        _hoisted_98,
                        _createVNode(_component_p_inputtext, {
                          modelValue: _ctx.kontrol,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.kontrol) = $event)),
                          placeholder: "klik disini untuk Masukan Nomor Surat Kontrol anda",
                          class: "w-full"
                        }, null, 8, ["modelValue"]),
                        (_ctx.errors.kontrol)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(_ctx.errors.kontrol), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_100, [
                    _hoisted_101,
                    _createVNode(_component_p_inputtext, {
                      modelValue: _ctx.no_tlp,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.no_tlp) = $event)),
                      placeholder: "klik disini untuk memasukan nomot tlp/HP",
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _hoisted_102,
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _createVNode(_component_p_button, {
                      onClick: _ctx.backTree,
                      severity: "info",
                      rounded: "",
                      outlined: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'circle-left'] }),
                        _createTextVNode(" Kembali")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _createVNode(_component_p_button, {
                      onClick: _ctx.kirim,
                      severity: "success",
                      rounded: "",
                      outlined: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Lanjut "),
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'circle-right'] })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.posisi == 5)
          ? (_openBlock(), _createBlock(_component_p_card, {
              key: 4,
              class: "mb-5 card"
            }, {
              title: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'ticket'] }),
                _createTextVNode(),
                _hoisted_106
              ]),
              content: _withCtx(() => [
                (_ctx.antrian)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_107, [
                      _createVNode(_component_antrian, { data: _ctx.antrian }, null, 8, ["data"])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_108,
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("div", _hoisted_110, [
                    _createVNode(_component_p_button, {
                      onClick: _ctx.backHome,
                      severity: "info",
                      rounded: "",
                      outlined: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'home'] }),
                        _createTextVNode(" Menu Awal")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isIklan)
        ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
            _createVNode(_component_p_card, { class: "mb-5 card" }, {
              content: _withCtx(() => []),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_p_confirm_dialog, { group: "headless" }, {
      container: _withCtx(({ message, acceptCallback, rejectCallback }) => [
        _createElementVNode("div", _hoisted_112, [
          _hoisted_113,
          _createElementVNode("span", _hoisted_114, _toDisplayString(message.header), 1),
          _createElementVNode("p", _hoisted_115, _toDisplayString(message.message), 1),
          _createElementVNode("div", _hoisted_116, [
            _createVNode(_component_p_button, {
              label: "Tutup",
              icon: "pi pi-times",
              outlined: "",
              onClick: rejectCallback
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}